import axios from 'axios';
import { Bookie } from '../components/TipPublish/interfaces/utils';

export const bookiesRequest = () =>
  axios
    .get(`/v1/bookies`)
    .then((res: any) => {
      const { bookies } = res;
      const activeBookies = bookies.filter((bookie: Bookie) => {
        return bookie.is_active;
      });
      return { bookies: activeBookies };
    })
    .catch((err) => err);
